function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.336 8.982a.128.128 0 00-.116-.083h-1.515L14.2 6.222a.162.162 0 00.004-.147.126.126 0 00-.112-.075h-2.046a.127.127 0 00-.114.08l-1.918 4.348a.161.161 0 00.005.14.126.126 0 00.109.07h1.315l-1.433 3.857a.156.156 0 00.051.18.117.117 0 00.165-.03l4.092-5.508a.16.16 0 00.018-.155z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 21.804L12.087 18H20a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h2v3.804zM11.513 16L8 18.196V16H4V4h16v12h-8.487z",
  fill: "#000"
});

function SvgCannedResponses(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCannedResponses;